import { html, i18n } from '@webtides/element-js';

export const renderValidationMessage = type => {
    switch (type) {
        case 'USER_FAIL':
            return USER_FAIL();
        case 'TECH_FAIL':
            return TECH_FAIL();
        default:
            return USER_FAIL();
    }
};

const USER_FAIL = () => {
    return html`
        <section class="my-4">
            <div class="flex items-start lg:items-center p-4 border-2 border-warning-600 text-warning-600 font-light">
                <svg-icon name="warning" class="pointer-events-none w-8 h-8 lg:w-16 lg:h-16 mr-4 md:mr-8"></svg-icon>
                <div class="w-full md:w-2/3">
                    ${i18n('form.field.recaptcha.validation.userFail', 'ReCaptcha-Prüfung gescheitert')}
                </div>
            </div>
        </section>
    `;
};

const TECH_FAIL = () => {
    return html`
        <section class="my-4 lg:my-8">
            <div class="flex items-start lg:items-center p-4 border-2 border-danger-600 text-danger-600 font-light">
                <svg-icon name="warning" class="pointer-events-none w-8 h-8 lg:w-16 lg:h-16 mr-4 md:mr-8"></svg-icon>
                <div class="w-full md:w-2/3">
                    ${i18n('form.field.recaptcha.validation.techFail', 'Es ist ein Captcha Fehler aufgetreten.')}
                </div>
            </div>
        </section>
    `;
};
